import React, { useEffect, useState } from 'react'
import {
  AskMeLaterBtn,
  FlexAlignCenter,
  PhoneInputError,
  PhoneInputPlaceHolder,
  WhatsappHeading,
  WhatsappHeadingDesc,
} from './style'
import WhatsappIcon from '../../../components/Images/WhatsappIcon'
import { PhoneInput } from '../../../components/FormComponents'
import { Popup } from '../../../components/Popup'

export default function WhatsAppSuccessPopUp({show}){
  const [showPopUp, updatePopUp] = useState(show)

  useEffect(() => {
    updatePopUp(show)
  },[show])

  return <Popup
    show={showPopUp}
    close={() => updatePopUp(false)}
    renderActions={
      <>
        <button
          className="action-button primary-button"
          type="button"
          onClick={() => updatePopUp(false)}
        >
          Okay
        </button>
      </>
    }
  >
    <FlexAlignCenter>
      <WhatsappIcon />
      <WhatsappHeading>Thank You!</WhatsappHeading>
    </FlexAlignCenter>
    <WhatsappHeadingDesc>
      You have successfully subscribed to notifications and updates over WhatsApp
    </WhatsappHeadingDesc>
  </Popup>
}